import React, { useMemo } from 'react';
import FormControl from '@material-ui/core/FormControl';
import { Field } from 'formik';
import { Select } from 'formik-material-ui';
import { InputLabel, MenuItem } from '@material-ui/core';

export const SelectVenueAgreement = ({ name, agreements, value }) => {
  const items = useMemo(
    () =>
      agreements?.map(({ id, name }) => (
        <MenuItem key={id} value={id}>
          {name}
        </MenuItem>
      )),
    [JSON.stringify(agreements)]
  );

  return (
    <FormControl>
      <InputLabel htmlFor={name}>&nbsp;</InputLabel>
      <Field as="select" name={name} component={Select} value={value}>
        {items}
      </Field>
    </FormControl>
  );
};
